import React, { memo } from "react";
import Box from "@mui/material/Box";
import Skeleton from "react-loading-skeleton";

import AppSkeletonTheme from "../../../../components/skeletons/AppSkeletonTheme";

/**
 * Skeleton khi PlantsPage đang tải category / sizes / special / list.
 */
const PlantsCatalogSkeleton: React.FC = () => (
  <AppSkeletonTheme borderRadius="10px">
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-start",
        width: "100%",
        minWidth: 0,
        maxWidth: "100%",
      }}
    >
      <Box
        sx={{
          marginTop: { xs: 0, sm: "8px" },
          width: { xs: "100%", sm: "650px", md: "800px", lg: "981px" },
          maxWidth: "100%",
          boxSizing: "border-box",
          px: { xs: 1.5, sm: 0 },
          minWidth: 0,
        }}
      >
        <Box
          sx={{
            display: { xs: "block", sm: "none" },
            ml: { xs: -1.5, sm: 0 },
            mr: { xs: -1.5, sm: 0 },
            width: { xs: "calc(100% + 24px)", sm: "100%" },
            px: 2,
            py: 1.5,
            bgcolor: "#ebebeb",
            borderBottom: "1px solid #cfcfcf",
            mb: 1,
          }}
        >
          <Box sx={{ display: "flex", gap: 1 }}>
            <Skeleton height={36} borderRadius={1} style={{ flex: 1 }} />
            <Skeleton height={36} borderRadius={1} style={{ flex: 1 }} />
          </Box>
        </Box>

        <Box
          sx={{
            display: { xs: "none", sm: "flex" },
            flexDirection: "row",
            gap: 1.5,
            mb: 1.5,
            alignItems: "flex-start",
          }}
        >
          <Skeleton width={200} height={280} borderRadius={2} />
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Skeleton width="40%" height={20} style={{ marginBottom: 12 }} />
            <Skeleton height={36} style={{ marginBottom: 8 }} />
            <Skeleton height={36} style={{ marginBottom: 8 }} />
            <Skeleton height={36} />
          </Box>
        </Box>

        <Box sx={{ width: "100%", minWidth: 0 }}>
          <Box sx={{ display: { xs: "none", sm: "block" }, mb: 1 }}>
            <Skeleton width="100%" height={36} borderRadius={1} />
          </Box>
          {Array.from({ length: 6 }).map((_, i) => (
            <Box
              key={i}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                py: 1.25,
                borderBottom: "1px solid #eee",
              }}
            >
              <Skeleton width={72} height={72} borderRadius={1} />
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Skeleton width="65%" height={18} style={{ marginBottom: 8 }} />
                <Skeleton width="40%" height={14} />
              </Box>
            </Box>
          ))}
        </Box>

        <Box sx={{ mt: 4, textAlign: "center" }}>
          <Skeleton width="60%" height={22} style={{ margin: "0 auto 16px" }} />
          <Skeleton height={180} borderRadius={2} />
        </Box>
      </Box>
    </Box>
  </AppSkeletonTheme>
);

export default memo(PlantsCatalogSkeleton);
